import type { ScopeSourceDefinition } from '@shared/lib/scope'

export const resolveSourceId = (
  param: ScopeSourceDefinition['param'],
  routeParams: Record<string, unknown>,
  disciplineId: number | null,
): number | null => {
  switch (param) {
    case 'discipline':
      return disciplineId
    case 'assessment':
      return Number(routeParams.assessment) || null
    case 'summarize':
      return Number(routeParams.summarize) || null
  }
}
